export default __webpack_public_path__ + "static/media/engine4.54d09f76.jpg";